// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"14a53abc","453":"f9af8ee5","615":"d3149fa4","820":"c53c65f6","893":"885b1a72"}[chunkId] + ".chunk.js";
};